// common place for all the new entities stracture, should be broken to proper file locations like formation-enums trajectory enums etc once once we implement it
import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities.js';

export enum EntityType {
  CoordinateReferenceSystem = 'CoordinateReferenceSystem',
  WellboreWellheadPosition = 'WellboreWellheadPosition',
  ProjectData = 'ProjectData',
  IPMFile = 'IPMFile',
  PorePressureP10 = 'PorePressureP10',
  PorePressureP50 = 'PorePressureP50',
  PorePressureP90 = 'PorePressureP90',
  FracturePressureP10 = 'FracturePressureP10',
  FracturePressureP50 = 'FracturePressureP50',
  FracturePressureP90 = 'FracturePressureP90',
  CollapsePressureP10 = 'CollapsePressureP10',
  CollapsePressureP50 = 'CollapsePressureP50',
  CollapsePressureP90 = 'CollapsePressureP90',
  MinimumHorizontalStressPressureP10 = 'MinimumHorizontalStressPressureP10',
  MinimumHorizontalStressPressureP50 = 'MinimumHorizontalStressPressureP50',
  MinimumHorizontalStressPressureP90 = 'MinimumHorizontalStressPressureP90',
  TemperatureListing = 'TemperatureListing',
  TemperatureDefinition = 'TemperatureDefinition',
  GeomagneticParameters = 'GeomagneticParameters',
  TrajectoryPlan = 'TrajectoryPlan',
  PositionalUncertaintyList = 'PositionalUncertaintyList',
  SurveyRun = 'SurveyRun',
  SurveyProgram = 'SurveyProgram',
  DefinitiveSurveyRun = 'DefinitiveSurveyRun',
  CovarianceMatrix = 'CovarianceMatrix',
  UncertaintyVectors = 'UncertaintyVectors',
  HoleSize = 'HoleSize',
  SiteReferenceSystem = 'SiteReferenceSystem',
}

export enum PressureProfileType {
  PorePressureP10 = 'Pore',
  PorePressureP50 = 'Pore',
  PorePressureP90 = 'Pore',
  FracturePressureP10 = 'Fracture',
  FracturePressureP50 = 'Fracture',
  FracturePressureP90 = 'Fracture',
  CollapsePressureP10 = 'Collapse',
  CollapsePressureP50 = 'Collapse',
  CollapsePressureP90 = 'Collapse',
  MinimumHorizontalStressPressureP10 = 'MinimumHorizontalStress',
  MinimumHorizontalStressPressureP50 = 'MinimumHorizontalStress',
  MinimumHorizontalStressPressureP90 = 'MinimumHorizontalStress',
  IPMFile = 'IPMFile',
}

export enum ReferencePositionType {
  Site = 'Site',
  Well = 'Well',
  Slot = 'Slot',
}

export enum WellConfigurationType {
  OnShore = 'Onshore',
  OffShore = 'Offshore',
}

export enum WellStatusType {
  Prototype = 'Prototype',
  Actual = 'Actual',
  Planned = 'Planned',
  Archived = 'Archived',
}

export enum DrillingUnitType {
  SemiSubmersible = 'Semisubmersible',
  Platform = 'Platform',
  LandRig = 'Landrig',
  TLP = 'TLP',
}

export enum BuildMethodsType {
  TieLine = 'TieLine',
  LineMD = 'LineMD',
  LineTVD = 'LineTDV',
  LineCL = 'LineCL',
  BT3Inc = 'BT3Inc',
  BT3Azi = 'BT3Azi',
  IncAziMD = 'IncAziMD',
  IncAziTVDED = 'IncAziTVDED',
  DLSIncAzi = 'DLSIncAzi',
  IncAziMDMCM = 'IncAziMDMCM',
  Dt1MD = 'Dt1MD',
  SlantWell = 'SlantWell',
  SWell = 'SWell',
  OptimumAlign = 'OptimumAlign',
  TangentToPointDLSHold = 'TangentToPointDLSHold',
  TangentToPointHoldDLS = 'TangentToPointHoldDLS',
}

export enum VectorTypes {
  GW = 'GW',
  SR = 'SR',
}

export enum TemperatureDefinitionNameType {
  LinearDefinition = 'Linear Definition',
  MultipleGradients = 'Multiple Gradients',
  Table = 'Table',
}

export const HIERARCHY_ENTITIES_INFO: { [key: string]: string; } = {
  [HierarchyLevelType.Archive]: 'archiveid',
  [HierarchyLevelType.Country]: 'countryid',
  [HierarchyLevelType.Field]: 'fieldid',
  [HierarchyLevelType.Site]: 'siteid',
  [HierarchyLevelType.Well]: 'wellid',
  [HierarchyLevelType.Wellbore]: 'wellboreid',
  [HierarchyLevelType.Design]: 'designid',
  [HierarchyLevelType.Node]: 'nodeid',
};

export enum MetadataType {
  Common = 'commonMetadata',
  Entity = 'entityMetadata',
}

export enum CommonMetadataType {
  Created = 'created',
  Synced = 'synced',
  // Owner = 'owner',
}

export enum EntityMetadataType {
  Vendor = 'vendor',
  Overlap = 'overlap',
}
export const DATE_FIELDS = [CommonMetadataType.Created, CommonMetadataType.Synced];

export const metadataLabelMap = {
  [CommonMetadataType.Created]: 'Created Date',
  [CommonMetadataType.Synced]: 'Updated Date',
  // [CommonMetadataType.Owner]: 'Owner',
  [EntityMetadataType.Vendor]: 'Vendor',
  [EntityMetadataType.Overlap]: 'Overlap',
};
